/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var DotCircleIcon = createIcon({
  name: 'DotCircleIcon',
  height: 512,
  width: 512,
  svgPath: 'M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default DotCircleIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/dot-circle-icon.js
// module id = 538
// module chunks = 0